<div class="interactive-pill" (click)="pillClick.emit()" [class.selected]="selected()" [class.disabled]="disabled()">
  {{ titleText() }}
  <mat-icon [hidden]="!selected() || !showCross()" [svgIcon]="'close'"></mat-icon>
</div>
